'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _dec2, _class; // Lib


// Components


// Util


// Constants


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _reactDnd = require('react-dnd');

var _shallowequal = require('shallowequal');

var _shallowequal2 = _interopRequireDefault(_shallowequal);

var _reselect = require('reselect');

var _renderThrottleDecorator = require('../../utils/milanoteRecompose/renderThrottleDecorator');

var _renderThrottleDecorator2 = _interopRequireDefault(_renderThrottleDecorator);

var _SelectedElementsDragPreviews = require('../../element/dnd/SelectedElementsDragPreviews');

var _SelectedElementsDragPreviews2 = _interopRequireDefault(_SelectedElementsDragPreviews);

var _ElementDragGroupPositioner = require('../../element/dnd/ElementDragGroupPositioner');

var _ElementDragGroupPositioner2 = _interopRequireDefault(_ElementDragGroupPositioner);

var _dragAndDropUtils = require('../../utils/dnd/dragAndDropUtils');

var _gridSizeSelector = require('../../utils/grid/gridSizeSelector');

var _elementConstants = require('../../../common/elements/elementConstants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var mapStateToProps = (0, _reselect.createSelector)(_gridSizeSelector.getGridSize, function (state) {
    return state.getIn(['app', 'dragging', 'hoveredTypes']);
}, function (gridSize, hoveredTypes, selectedIds) {
    return {
        gridSize: gridSize,
        hoveredTypes: hoveredTypes
    };
});

/**
 * Produces a map of CSS class names depending on the type of element that's hovered.
 *
 * @param monitor {DragLayerMonitor} The React DnD drag layer monitor.
 * @param hoveredTypes {Immutable.Map} An immutable map of hovered types.
 * @returns {Array} A an array of CSS class names that should be applied to the element
 */
var getHoveredTypes = function getHoveredTypes(monitor) {
    var targetIds = monitor.isDragging() ? monitor.getTargetIds() : [];

    var overClasses = targetIds.filter(function (id) {
        return monitor.isOverTarget(id) && monitor.canDropOnTarget(id);
    }).map(function (id) {
        return monitor.registry.handlers[id] && monitor.registry.handlers[id].props;
    }).filter(function (props) {
        return props.targetType;
    }).map(function (props) {
        return props.targetType;
    });

    return overClasses;
};

var createMemoisedGetHoveredTypes = function createMemoisedGetHoveredTypes() {
    var lastHoveredTypes = [];

    return function (monitor) {
        var hoveredTypes = getHoveredTypes(monitor);
        if (!(0, _shallowequal2.default)(lastHoveredTypes, hoveredTypes)) {
            lastHoveredTypes = hoveredTypes;
        }
        return lastHoveredTypes;
    };
};

/**
 * Along with the usual hovered item information & position, this also determines what target types, if any, the item
 * is hovering over and determines the appropriate classes to add.
 */
var createCollect = function createCollect() {
    var memoisedGetHoveredTypes = createMemoisedGetHoveredTypes();
    var prevCollectProps = {};

    return function (monitor) {
        if (monitor.getItemType() === _elementConstants.ELEMENT_DND_TYPE) {
            prevCollectProps = {
                item: monitor.getItem(),
                itemType: monitor.getItemType(),
                hoveredTypes: memoisedGetHoveredTypes(monitor),
                clientOffset: monitor.getClientOffset(),
                sourceClientOffset: monitor.getSourceClientOffset(),
                initialSourceClientOffset: monitor.getInitialSourceClientOffset(),
                initialClientOffset: monitor.getInitialClientOffset()
            };
        }

        return prevCollectProps;
    };
};

var ElementDragLayer = (_dec = (0, _reactRedux.connect)(mapStateToProps), _dec2 = (0, _reactDnd.DragLayer)(createCollect()), _dec(_class = _dec2(_class = (0, _renderThrottleDecorator2.default)(_class = function (_React$Component) {
    _inherits(ElementDragLayer, _React$Component);

    function ElementDragLayer(props) {
        _classCallCheck(this, ElementDragLayer);

        var _this = _possibleConstructorReturn(this, (ElementDragLayer.__proto__ || Object.getPrototypeOf(ElementDragLayer)).call(this, props));

        _this.state = { dragOrigin: null };
        return _this;
    }

    _createClass(ElementDragLayer, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var itemType = nextProps.itemType;

            if (itemType !== _elementConstants.ELEMENT_DND_TYPE) return;

            if (nextProps.initialClientOffset === this.props.initialClientOffset && this.state.dragOrigin) return;

            if (nextProps.initialClientOffset) {
                this.setState({
                    dragOrigin: (0, _dragAndDropUtils.getElementDragOrigin)(nextProps)
                });

                return;
            }

            this.setState({ dragOrigin: null });
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                item = _props.item,
                itemType = _props.itemType;
            var dragOrigin = this.state.dragOrigin;

            var _props2 = this.props,
                hoveredTypes = _props2.hoveredTypes,
                rest = _objectWithoutProperties(_props2, ['hoveredTypes']); // eslint-disable-line no-unused-vars

            if (itemType !== _elementConstants.ELEMENT_DND_TYPE || !item || !item.element) return null;

            return _react2.default.createElement(
                'div',
                { className: 'ElementDragLayer' },
                _react2.default.createElement(
                    _ElementDragGroupPositioner2.default,
                    this.props,
                    _react2.default.createElement(_SelectedElementsDragPreviews2.default, _extends({}, rest, { dragOrigin: dragOrigin }))
                )
            );
        }
    }]);

    return ElementDragLayer;
}(_react2.default.Component)) || _class) || _class) || _class);


ElementDragLayer.propTypes = {
    currentBoardId: _propTypes2.default.string.isRequired,
    hoveredTypes: _propTypes2.default.object,
    monitor: _propTypes2.default.object,
    item: _propTypes2.default.object,
    itemType: _propTypes2.default.string,
    gridSize: _propTypes2.default.number,
    clientOffset: _propTypes2.default.number,
    initialClientOffset: _propTypes2.default.number,
    initialSourceClientOffset: _propTypes2.default.number
};

exports.default = ElementDragLayer;


//////////////////
// WEBPACK FOOTER
// ./src/client/workspace/dnd/ElementDragLayer.js
// module id = 2159
// module chunks = 0